import { render, staticRenderFns } from "./soltList.vue?vue&type=template&id=2ce6413d&scoped=true&"
import script from "./soltList.vue?vue&type=script&lang=js&"
export * from "./soltList.vue?vue&type=script&lang=js&"
import style0 from "./soltList.vue?vue&type=style&index=0&id=2ce6413d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce6413d",
  null
  
)

export default component.exports